import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import globalIP from '@/GlobelIP';
import garment4 from '../../pages/catalogue/formatsPage/garment4.jpg';
declare module 'jspdf' {
  interface jsPDF {
    autoTable: (options: object) => jsPDF;
  }
}

const loadImage = url => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
};
const generatePDF = async (
  data,
  cataloguecatappt,
  label,
  data2,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName
) => {
  const doc = new jsPDF('landscape');

  const startX = 10;
  const startY = 10;
  const cellWidth = 30;
  const cellHeight = 20; // minimum height
  const headerCellHeight = 10;
  const fontSize = 9;
  const tableLineWidth = 0.1;

  doc.setFontSize(fontSize);

  const attributeDisplayNames = {
    aliascd: `${label[0]?.attributes.AliasCode}`,
    CoverImage: 'Image',
    description: `${label[0]?.attributes.Description}`,
    productname: `${label[0]?.attributes.ProductName}`,
    prodtypecd: `${label[0]?.attributes.ProductType}`,
    Dimension: 'Dimension',
    finish: `${label[0]?.attributes.finish}/${label[0]?.attributes.color}`,
    saleprice: `${label[0]?.attributes.SalePrice}`,
    netwgt: `${label[0]?.attributes.NetWgt}`
  };

  const cmpnam = data2.map(item => item.attributes.cmpnm);
  const address = data2.map(item => item.attributes.address);
  const logoUrl = data2.length > 0 ? data2[0].attributes?.Logo?.data?.attributes?.url : '';
  const img = `${globalIP}${logoUrl}`;

  const logoWidth = 40;
  const logoHeight = 10;
  const logoX = startX + 10;
  const logoY = startY + 3;
  doc.addImage(img, 'JPEG', logoX, logoY, logoWidth, logoHeight);

  const boxWidth = 270;
  const boxHeight = 20;
  const boxX = startX;
  const boxY = startY;
  const boxText = cmpnam.length > 0 ? cmpnam[0] : 'Company Name';
  doc.rect(boxX, boxY, boxWidth, boxHeight);

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  const textWidth = doc.getStringUnitWidth(boxText) * doc.internal.scaleFactor;
  const textX = boxX + (boxWidth - textWidth) / 2;
  const textY = boxY + boxHeight / 3;
  doc.text(boxText, textX, textY);

  const addressText = address.length > 0 ? address[0] : 'Address';
  const addressTextWidth = doc.getStringUnitWidth(addressText) * doc.internal.scaleFactor;
  const addressTextX = boxX + (boxWidth - addressTextWidth) / 2;
  const addressTextY = boxY + boxHeight / 2;
  doc.text(addressText, addressTextX, addressTextY);

  // Header cells
  let currentX = startX;
  let currentY = boxY + boxHeight;

  Object.keys(attributeDisplayNames).forEach(key => {
    doc.setFillColor('#D3D3D3');
    doc.rect(currentX, currentY, cellWidth, headerCellHeight, 'F');
    doc.rect(currentX, currentY, cellWidth, headerCellHeight, 'S');

    doc.setTextColor(0, 0, 0);
    const headerText = doc.splitTextToSize(attributeDisplayNames[key], cellWidth - 4);
    doc.text(headerText, currentX + 2, currentY + 5);

    currentX += cellWidth;
  });

  currentY += headerCellHeight;

  const addNewPageIfNecessary = (heightNeeded) => {
    if (currentY + heightNeeded > doc.internal.pageSize.getHeight() - 10) {
      doc.addPage();
      currentY = 10;
    }
  };

  // Process products
  for (const product of cataloguecatappt) {
    currentX = startX;

    // Calculate max row height
    let maxRowHeight = cellHeight;
    Object.keys(attributeDisplayNames).forEach(key => {
      if (key === 'CoverImage' || key === 'Dimension') return;

      const cellContent = product[key]?.toString() || '';
      const wrappedText = doc.splitTextToSize(cellContent, cellWidth - 4);
      maxRowHeight = Math.max(maxRowHeight, wrappedText.length * 4); // 4 = line height
    });

    // Check if row fits, else add page
    addNewPageIfNecessary(maxRowHeight);

    // Render row
    for (const key of Object.keys(attributeDisplayNames)) {
      doc.rect(currentX, currentY, cellWidth, maxRowHeight, 'S');

      if (key === 'CoverImage') {
        const imageX = currentX + 4;
        const imageY = currentY + 2;
        const imageWidth = cellWidth - 8;
        const imageHeight = maxRowHeight - 4;

        const matchingProduct = data.find(item => item.id == product.CatalogProduct);
        if (matchingProduct && matchingProduct.attributes.CoverImage) {
          const imageUrl = `${globalIP}${matchingProduct.attributes.CoverImage?.data?.attributes?.url}`;

          try {
            const img = await loadImage(imageUrl);
            let image = imageUrl;
            if (watermark) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);
              const response = await fetch(mergedImageBase64);
              const imageBuffer = await response.arrayBuffer();
              const blob = new Blob([imageBuffer], { type: 'image/png' });
              const imageUrl2 = URL.createObjectURL(blob);
              image = imageUrl2;
            }

            const aspectRatio = img.width / img.height;
            let scaledWidth = imageWidth;
            let scaledHeight = imageWidth / aspectRatio;
            if (scaledHeight > imageHeight) {
              scaledHeight = imageHeight;
              scaledWidth = imageHeight * aspectRatio;
            }

            doc.addImage(image, 'JPEG', imageX, imageY, scaledWidth, scaledHeight);
          } catch (error) {
            console.error('Error loading image:', error);
          }
        }
      } else if (key === 'Dimension') {
        const matchingProduct = data.find(item => item.id == product.CatalogProduct);
        const dimensionString =
          `${matchingProduct?.attributes?.Length || '0'} x ` +
          `${matchingProduct?.attributes?.Width || '0'} x ` +
          `${matchingProduct?.attributes?.Height || '0'} ` +
          `${matchingProduct?.attributes?.SizeUnit || ''}`;
        doc.text(dimensionString, currentX + 2, currentY + maxRowHeight / 2);
      } else {
        const cellContent = product[key]?.toString() || '';
        const wrappedText = doc.splitTextToSize(cellContent, cellWidth - 4);
        const lineHeight = 4;
        wrappedText.forEach((line, index) => {
          doc.text(line, currentX + 2, currentY + 7 + index * lineHeight);
        });
      }

      currentX += cellWidth;
    }

    currentY += maxRowHeight;
  }

  return doc;
};

const generatePDF2 = async (
  data,
  cataloguecatappt,
  label,
  data2,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName,
  catapdf,
  buyercatapdf,
  buyername
) => {
  const doc = new jsPDF('portrait');
  const logoUrl = data2.length > 0 ? data2[0].attributes?.Logo?.data?.attributes?.url : '';

  const startX = 10;
  const startY = 20;
  const cellWidth = 100;
  const cellHeight = 10;
  const fontSize = 10;
  const tableLineWidth = 0.1;

  const attributeDisplayNames = {
    aliascd: `${label[0]?.attributes.AliasCode}`,
    description: `${label[0]?.attributes.Description}`,
    productname: `${label[0]?.attributes.ProductName}`,
    prodtypecd: `${label[0]?.attributes.ProductType}`,
    Dimension: 'Dimension',
    finish: `${label[0]?.attributes.finish}/${label[0]?.attributes.color}`,
    saleprice: `${label[0]?.attributes.SalePrice}`,
    netwgt: `${label[0]?.attributes.NetWgt}`
  };

  const addNewPageIfNecessary = currentY => {
    if (currentY + cellHeight > doc.internal.pageSize.getHeight() - 10) {
      doc.addPage();
      return 10; // Start from the top of the new page
    }
    return currentY;
  };

  const displayProduct = async (product, currentX, currentY, catadata) => {
    const imageX = currentX + 10; // Left margin for image
    const imageY = currentY;
    const imageWidth = 80; // Fixed width for the image container
    const imageHeight = 80; // Fixed height for the image container

    const contentX = imageX + imageWidth + 10; // Right of the image container
    const contentY = currentY;

    // Draw Image Container
    const value = product.find(item => item.id == catadata.CatalogProduct);
    if (value) {
      const imageUrl = `${globalIP}${value.attributes.CoverImage?.data?.attributes?.url}`;
      let image = imageUrl;
      if (watermark) {
        const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

        // Convert Base64 to ArrayBuffer
        const response = await fetch(mergedImageBase64);
        const imageBuffer = await response.arrayBuffer();
        const blob = new Blob([imageBuffer], { type: 'image/png' }); // Adjust the MIME type if needed

        // Create a URL from the Blob
        const imageUrl2 = URL.createObjectURL(blob);
        image = imageUrl2;
      }

      await new Promise(resolve => {
        const img = new Image();
        img.src = imageUrl;

        img.onload = () => {
          const imgWidth = img.width;
          const imgHeight = img.height;
          const aspectRatio = imgWidth / imgHeight;

          let newWidth, newHeight;
          if (imgWidth > imgHeight) {
            newWidth = imageWidth;
            newHeight = newWidth / aspectRatio;
          } else {
            newHeight = imageHeight;
            newWidth = newHeight * aspectRatio;
          }

          doc.addImage(image, 'JPEG', imageX, imageY, newWidth, newHeight);
          resolve(); // Resolve the promise after the image is added
        };

        img.onerror = () => {
          resolve(); // Resolve even if the image fails to load
        };
      });
    } else {
      doc.rect(imageX, imageY, imageWidth, imageHeight); // Placeholder if image fails
    }

    // Draw Content Table
    let currentTableY = contentY;
    doc.setFontSize(fontSize);
    Object.keys(attributeDisplayNames).forEach(key => {
      const attributeLabel = attributeDisplayNames[key];
      const attributeValue = catadata[key] || '';

      // Draw border for each cell
      doc.setLineWidth(tableLineWidth);
      doc.rect(110, currentY, cellWidth - 10, cellHeight, 'S');

      // Draw lines between attribute and value
      const lineX = 110 + cellWidth / 3.1;
      const lineY1 = currentY;
      const lineY2 = currentY + cellHeight;
      doc.line(lineX, lineY1, lineX, lineY2);

      // Display attribute label and value
      doc.text(attributeLabel, 110 + 0.5, currentY + 7);

      if (key === 'description') {
        const descriptionLines = doc.splitTextToSize(attributeValue.toString(), 95 - 39);
        const displayedDescription = descriptionLines.slice(0, 2).join('\n');

        doc.text(displayedDescription, 110 + 33, currentY + 4);
        // Display the description text in multiple lines within the cell

        if (descriptionLines.length > 2) {
          // If there are more than 2 lines, add an indicator
          doc.text('.', 110 + 33, currentY + 4 + 7); // Adjust vertical position as needed
        }
      } else if (key === 'productname') {
        const descriptionLines = doc.splitTextToSize(attributeValue.toString(), 95 - 39);
        const displayedDescription = descriptionLines.slice(0, 2).join('\n');

        doc.text(displayedDescription, 110 + 33, currentY + 4);
        // Display the description text in multiple lines within the cell

        if (descriptionLines.length > 2) {
          // If there are more than 2 lines, add an indicator
          doc.text('.', 110 + 33, currentY + 4 + 7); // Adjust vertical position as needed
        }
      } else if (key === 'Dimension') {
        // Handle Dimension cell
        const dimensionString = `${catadata?.len || '0'} x ${catadata?.wid || '0'} x ${catadata?.thick || '0'
          } ${catadata?.unit || 'unit'}`;
        doc.setLineWidth(tableLineWidth);
        doc.rect(110, currentY, cellWidth - 10, cellHeight, 'S');
        doc.text(dimensionString, 110 + 34, currentY + 7);
      } else if (key === 'finish') {
        // Handle FinishName cell
        const dimensionString = `${catadata?.finish} / ${catadata?.color}`;
        doc.setLineWidth(tableLineWidth);
        doc.rect(110, currentY, cellWidth - 10, cellHeight, 'S');
        doc.text(dimensionString, 110 + 34, currentY + 7);
      } else {
        doc.text(attributeValue.toString(), 110 + cellWidth / 3, currentY + 7);
      }

      currentY += cellHeight; // Adjust vertical position
    });

    // Add gap between products
    return Math.max(currentY + imageHeight, currentTableY) - 70;
  };

  let pdimage = null;

  if (buyername && buyercatapdf.length > 0) {
    pdimage = buyercatapdf[0]?.attributes?.CPPath?.data?.attributes?.url;
  } else if (catapdf.length > 0) {
    pdimage = catapdf[0]?.attributes?.CPPath?.data?.attributes?.url;
  }

  // Fallback to default image if none exists
  const pdimg = pdimage ? `${globalIP}${pdimage}` : garment4;

  doc.addImage(pdimg, 'JPEG', 0, 0, 210, 300);
  doc.addPage();

  let currentX = startX;
  let currentY = startY;

  for (const product of cataloguecatappt) {
    currentY = addNewPageIfNecessary(currentY);
    currentY = await displayProduct(data, currentX, currentY, product);
  }

  return doc;
};
const handleDownloadPDF = async (
  cata,
  cataloguecatappt,
  label,
  data2,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName
) => {
  try {

    if (Array.isArray(cata[0])) {
      for (let i = 0; i < cata.length; i++) {
        const subCata = cata[i];

        // 🛠️ Match CatalogueProduct using correct fields
        const seenProductIds = new Set();
        const subCataloguecatappt = cataloguecatappt.filter(item =>
          subCata.some(prod =>
            (String(prod.id) === String(item.CatalogProduct) ||
              String(prod.attributes?.ProductId) === String(item.ProductId)) &&
            !seenProductIds.has(item.CatalogProduct) && !seenProductIds.has(item.ProductId) &&
            seenProductIds.add(item.CatalogProduct) // Add to the Set after checking for duplication
          )
        );
        // console.log(`Group ${i + 1} - Matching items:`, subCataloguecatappt.length);

        const doc = await generatePDF(
          subCata,
          subCataloguecatappt,
          label,
          data2,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          cataName
        );

        doc.save(`${cataName[i]}.pdf`);
      }
    } else {
      const doc = await generatePDF(
        cata,
        cataloguecatappt,
        label,
        data2,
        watermark,
        mergeImagesWithWatermark,
        watermarkUrl,
        cataName
      );
      doc.save(`${cataName}.pdf`);
    }
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

const handleDownloadPDF2 = async (
  cata,
  cataloguecatappt,
  label,
  data2,
  watermark,
  mergeImagesWithWatermark,
  watermarkUrl,
  cataName,
  catapdf,
  buyercatapdf,
  buyername
) => {
  try {
    if (Array.isArray(cata[0])) {
      // Multi-dimensional: loop over each group and generate separate PDF
      for (let i = 0; i < cata.length; i++) {
        const subCata = cata[i];

        // 🛠️ Match CatalogueProduct using correct fields
        const seenProductIds = new Set();
        const subCataloguecatappt = cataloguecatappt.filter(item =>
          subCata.some(prod =>
            (String(prod.id) === String(item.CatalogProduct) ||
              String(prod.attributes?.ProductId) === String(item.ProductId)) &&
            !seenProductIds.has(item.CatalogProduct) && !seenProductIds.has(item.ProductId) &&
            seenProductIds.add(item.CatalogProduct) // Add to the Set after checking for duplication
          )
        );

        // 🧾 Generate PDF for each subgroup
        const pdfDoc = await generatePDF2(
          subCata,
          subCataloguecatappt,
          label,
          data2,
          watermark,
          mergeImagesWithWatermark,
          watermarkUrl,
          cataName,
          catapdf,
          buyercatapdf,
          buyername
        );

        // 💾 Save the subgroup PDF
        pdfDoc.save(`${cataName[i]}.pdf`);
      }
    } else {
      // Flat array: generate single PDF
      const pdfDoc = await generatePDF2(
        cata,
        cataloguecatappt,
        label,
        data2,
        watermark,
        mergeImagesWithWatermark,
        watermarkUrl,
        cataName,
        catapdf,
        buyercatapdf,
        buyername
      );

      pdfDoc.save(`${cataName}.pdf`);
    }
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};


export { handleDownloadPDF, handleDownloadPDF2 };


